import { render, staticRenderFns } from "./AssessmentItem3.vue?vue&type=template&id=1a11d71d&scoped=true&"
import script from "./AssessmentItem3.vue?vue&type=script&lang=js&"
export * from "./AssessmentItem3.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentItem3.vue?vue&type=style&index=0&id=1a11d71d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11d71d",
  null
  
)

export default component.exports